import { useQuery } from '@apollo/client';

import { COMPANY_ID, REDIRECT } from '@/shared/hooks/useCannyUrl/constants';
import GET_CANNY_TOKEN_QUERY from '@/shared/hooks/useCannyUrl/graphql/GetCannyTokenQuery.v4.b2b.graphql';
import type { GetCannyTokenQuery } from '@/shared/hooks/useCannyUrl/graphql/types/GetCannyTokenQuery';

const useFeedbackRoute = () => {
  const { loading, data } = useQuery<GetCannyTokenQuery>(
    GET_CANNY_TOKEN_QUERY,
    {
      context: { clientName: 'v4.b2b' },
    },
  );

  const ssoToken = String(data?.cannyToken);

  return {
    companyId: COMPANY_ID,
    ssoToken,
    redirect: REDIRECT,
    isLoading: loading,
  };
};

export default useFeedbackRoute;
